import React, { useEffect, useRef } from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
// eslint-disable-next-line import/no-extraneous-dependencies
import Lottie from "lottie-react";

import SuccessAnimationData from "../../../assets/images/common/animation/SuccessAnimation.json";

import "./TestDirectoryModals.css";

export default function TestDirectoryRequestSuccessModal({
  open,
  message,
  onClose,
  onDone,
}) {
  const lottieRef = useRef(null);

  const playSuccessAnimation = () => {
    if (lottieRef.current) {
      lottieRef.current.goToAndPlay(0, true);
    }
  };

  useEffect(() => {
    if (!open) return undefined;
    const timer = window.setTimeout(playSuccessAnimation, 200);
    return () => window.clearTimeout(timer);
  }, [open]);

  const handleAfterOpenChange = (isOpen) => {
    if (isOpen) {
      playSuccessAnimation();
    }
  };

  const handleDone = () => {
    if (typeof onDone === "function") onDone();
    else if (typeof onClose === "function") onClose();
  };

  return (
    <Modal
      open={open}
      closable
      centered
      footer={null}
      onCancel={onClose}
      afterOpenChange={handleAfterOpenChange}
      width={591}
      wrapClassName="TestDirectoryModal TestDirectoryModal--unlockSuccess"
      className="TestDirectoryModal TestDirectoryModal--unlockSuccess"
      closeIcon={<CloseOutlined className="SampleSubmissionModal__closeIcon" />}
      destroyOnHidden
    >
      <div className="TestDirectoryModal__Success">
        <div className="TestDirectoryModal__SuccessAnimation" aria-hidden>
          <Lottie
            lottieRef={lottieRef}
            animationData={SuccessAnimationData}
            loop={false}
            autoplay={false}
          />
        </div>
        <p className="TestDirectoryModal__Subtitle TestDirectory__UnlockSuccessText">
          {message}
        </p>
        <Button
          type="primary"
          className="TestDirectoryModal__SuccessDoneBtn"
          onClick={handleDone}
        >
          Done
        </Button>
      </div>
    </Modal>
  );
}
